<div
  data-testid="component-inline-alert"
  class="flex items-center text-sm px-4 py-3 rounded"
  [ngClass]="classes()"
  [attr.role]="role()"
  [attr.aria-live]="ariaLive()"
>
  <mat-icon class="pr-8" aria-hidden="true">{{ usedIcon() }}</mat-icon>

  <p class="whitespace-break-spaces" data-testid="component-inline-alert-text">
    <ng-content></ng-content>

    {{ label() }}
  </p>
</div>
